import { calculateDateRange, formatDateRange } from './DateFilter/utils';
import { FilterConfig } from './types';

export const getFilterValueLabel = (
  filter: FilterConfig,
  value: string | string[]
): string => {
  switch (filter.type) {
    case 'DATE': {
      const dateRange = calculateDateRange(value as string);
      return formatDateRange(dateRange);
    }
    case 'SINGULAR': {
      const option = filter.options.find((opt) => opt.value === value);
      return option?.label || '';
    }

    case 'MULTIPLE': {
      const values = value as string[];
      const selectedOptions = filter.options.filter((opt) =>
        values.includes(opt.value)
      );

      if (selectedOptions.length === 0) return '';
      if (selectedOptions.length === 1) return selectedOptions[0].label;
      return `${selectedOptions[0].label} + ${selectedOptions.length - 1}`;
    }
    default:
      return '';
  }
};

export const isFilterValueEmpty = (value: string | string[]): boolean => {
  if (Array.isArray(value) && value.length === 0) return true;
  if (value === '') return true;
  return false;
};